import { render, staticRenderFns } from "./PrintableSavedGoalPage.vue?vue&type=template&id=49db9686&scoped=true"
import script from "./PrintableSavedGoalPage.vue?vue&type=script&lang=js"
export * from "./PrintableSavedGoalPage.vue?vue&type=script&lang=js"
import style0 from "./PrintableSavedGoalPage.vue?vue&type=style&index=0&id=49db9686&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49db9686",
  null
  
)

export default component.exports